import { gql } from "@apollo/client";
import { useSuspenseQuery } from "@apollo/client/react";

import GQLUser from "./User.graphql";

export default function useUser() {
    return useSuspenseQuery<{ user: User }>(
        gql(GQLUser),
    )?.data?.user;
}

interface User {
    appMetadata: {
        roles?: {
            resource: { brandID: string }
            role: string
        }[]
    }
}
